export default function TimelineReport($interval, $window){
  return {
    restrict: "EA",
    template: require("./Novinky.html"),
  }
}


// WEBPACK FOOTER //
// ./src/novinky/Novinky.js